import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { getEmployeeList } from "../../redux/actions/userAction/userAction";
import { useSelector, useDispatch } from "react-redux";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import { textBoxStrLength } from "../../config/config";
import {
  fetchCurrentAttendeesList,
  fetchExistingGuest,
} from "../../redux/actions/meetingActions/MeetingAction";
import Select from "react-select";
import { rejectReassignRequest ,getactionActivitiesDetails} from "../../redux/actions/actionAction/ActionAction";
import LoaderButton from "../Common/LoaderButton";
import { checkDuplicateUser } from "../../redux/actions/userAction/userAction";
import RemoveAttendeesModalAction from "../Meeting/RemoveAttendeesModalNew";
import AttendeeDragDropNew from "../Meeting/AttendeeDragDropNew";

import SmallLoaderButton from "../Common/SmallLoaderButton";

const ReassignModal = (props) => {
  const regularExpression = /^[0-9a-zA-Z .,:;()/\-_\n]+$/;
  const regularExpressionName = /^[0-9a-zA-Z .,:;()/\-_]+$/;
  const regularExpressionForAgendaTitle =
    /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
  const userData = JSON.parse(localStorage.getItem("userData"));
  const accessToken = localStorage.getItem("accessToken");
  const dispatch = useDispatch();
  const meetingData = useSelector((state) => state.meeting);
  const actionData = useSelector((state) => state.action);
  const employeeData = useSelector((state) => state.user);
  const [reason, setReason] = useState("");
  const [date, setDate] = useState("");
  const [attendeeOptions, setAttendeeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [existingGuestOptions, setExistingGuestOptions] = useState([]);

  const [selectedAttendeeOption, setSelectedAttendeeOption] = useState(null);
  const [selectedEmployeeOption, setSelectedEmployeeOption] = useState(null);
  const [selectedExistingGuestOption, setSelectedExistingGuestOption] =
    useState(null);
  const [allGuestList, setAllGuestList] = useState([]);

  const [addNewSubOption, setAddNewSubOption] = useState("");
  const [addNewPeopleType, setAddNewPeopleType] = useState("");
  const [errors, setErrors] = useState({});
  const [addedUserError, setAddedUserError] = useState("");
  const [attendData, setAttendData] = useState([
    { id: "", name: "", email: "", profilePicture: "" },
  ]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [removeAttendeeData, setRemoveAttendeeData] = useState({});

  const [formData, setFormData] = useState({
    reason: "",
    priority: "",
    attendyType: "fromCurrentMeeting",
    responsiblePersonId: [],
    name: "",
    email: "",
    acceptStatus: "accept",
    attendeeId: null,
    date: null,
    companyName: null,
    designation: null,
    role: null,
    department: null,
  });

  useEffect(() => {
    if (props?.actionData?.meetingId) {
      setFormData((prev) => ({
        ...prev,
        priority: props?.actionData?.priority,
        dueDate: props?.actionData?.dueDate,
      }));

      const d = new Date(props.actionData.dueDate);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      setFormData((prev) => ({
        ...prev,
        date: `${year}-${month}-${day}`,
      }));

      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          props?.actionData?.meetingId,
          accessToken
        )
      );
      if (props.isFromViewAction === true) {
        // alert("IN IF")
        setAttendData(props.actionData.assignedUserDetail);
      } else {
        // alert("IN ELSE")
        setAttendData(props.actionData.assignedUserDetails);
      }

      if (Array.isArray(props?.actionData?.assignedUserDetails)) {
        setAttendData((prevAttendData) => {
          const existingAttendees = prevAttendData || [];

          const newAttendees = props.actionData.assignedUserDetails.filter(
            (newUser) => {
              const newUserId = newUser.id || newUser._id || "";
              const newUserEmail = newUser.email || "";
              return !existingAttendees.some((attendee) => {
                const existingId = attendee.id || attendee._id || "";
                const existingEmail = attendee.email || "";
                return (
                  (newUserId && newUserId === existingId) ||
                  (newUserEmail && newUserEmail === existingEmail)
                );
              });
            }
          );

          return [...existingAttendees, ...newAttendees];
        });
      }
    }

    if (props?.actionData?.meetingId) {
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          props?.actionData?.meetingId,
          accessToken
        )
      );
    }
    setSelectedEmployeeOption([{ label: "Name / Emp Id", value: "" }]);
  }, [props?.actionData?.meetingId, props.isModalOpen]);

  useEffect(() => {
    if (actionData?.isSuccess === true) {
      setReason("");
      setErrors({});
      props.setIsReassignModalOpen(false);
      setFormData({
        ...formData,
        reason: "",
        priority: "",
        attendyType: "fromCurrentMeeting",
        responsiblePersonId: [],
        name: "",
        email: "",
        acceptStatus: "accept",
        date: null,
        designation: null,
        companyName: null,
        role: null,
        department: null,
      });
    }
    return () => {
      setFormData({
        ...formData,
        reason: "",
        priority: "",
        attendyType: "fromCurrentMeeting",
        responsiblePersonId: [],
        name: "",
        email: "",
        acceptStatus: "accept",
        date: null,
        designation: null,
        companyName: null,
        role: null,
        department: null,
      });
    };
  }, [actionData?.isSuccess]);

  const handleSubmit = async () => {
    // alert(111111)
    const newErrors = validateForm();
    setErrors(newErrors);

    if (Object.keys(newErrors).length !== 0) return;

    const { acceptStatus, reason } = formData;
    const lastActionActivityId = props?.activityId;
    setDate(props?.actionData?.mainDueDate);
    if (acceptStatus === "accept") {
      if (!attendData || attendData.length === 0) {
        setErrors(constantMessages.responsiblePersonRequired);
        return;
      }

      const formattedAssignedUsers = attendData
        .filter((user) => user.name?.trim() && user.email?.trim())
        .map((user) => ({
          _id: user._id || user.id,
          name: user.name,
          email: user.email,
          isEmployee: user.isEmployee || false,
          designation: user.designation || "",
          companyName: user.companyName || "",
          role: user.role || "",
          department: user.department || "",
          profilePicture: user.profilePicture || "",
          isNewUser: user.isNewUser ? user.isNewUser : false,
        }));

      props.handleSubmit({
        ...formData,
        lastActionActivityId: props?.activityId,
        assignedUsers: formattedAssignedUsers,
      });
          //   alert(props?.actionId)
          if(props.isFromViewAction)
            {
              //alert(props?.actionData?._id)
dispatch(getactionActivitiesDetails(props?.actionData?._id, accessToken));
            }   
      // closeModal();
      setTimeout(() => {
        closeModal();
      }, 5000);
      


      
      //  dispatch(getactionActivitiesDetails(props?.actionId, props?.accessToken));
    } else {
      // Handle reject
      const payload = {
        rejectDetails: reason,
        assignedUserId: props?.actionData?.assignedUserDetail,
        lastActionActivityId: props?.activityId,
      };

      dispatch(rejectReassignRequest(props.actionId, payload, accessToken));
        //alert("reject")
      dispatch(getactionActivitiesDetails(props?.actionId, props?.accessToken));
      setTimeout(() => {
        closeModal();
      }, 10000);
      //  dispatch(getactionActivitiesDetails(props?.actionId, props?.accessToken));
    }

    setAttendData([{ id: "", name: "", email: "", profilePicture: "" }]);
    setFormData({
      reason: "",
      priority: "",
      attendyType: "fromCurrentMeeting",
      responsiblePersonId: [],
      name: "",
      email: "",
      acceptStatus: "accept",
      attendeeId: "",
      date: null,
      companyName: null,
      designation: null,
      role: null,
      department: null,
    });
  };

  useEffect(() => {
    if (meetingData?.currentAttendeesList?.length > 0) {
      const filtered = meetingData.currentAttendeesList.filter((attendee) => {
        return !attendData?.some(
          (assigned) =>
            assigned.email?.toLowerCase() === attendee.email?.toLowerCase()
        );
      });

      const meetingAttendee = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.email}`,
        name: "attendeeId",
        profilePicture: attendee.profilePicture,
      }));
      setAttendeeOptions(meetingAttendee);
    }
  }, [meetingData, attendData]);

  const validateForm = () => {
    const errors = {};

    const isAccept = formData.acceptStatus === "accept";

    if (!formData?.reason?.trim()) {
      errors.reason = constantMessages.reasonRequired;
    } else if (
      formData.reason.trim().length < 3 ||
      formData.reason.trim().length > 500
    ) {
      errors.reason = constantMessages.largeStringLengthError;
    } else if (!regularExpressionForAgendaTitle.test(formData.reason.trim())) {
      errors.reason = constantMessages.invalidReason;
    }

    if (isAccept) {
      if (formData.attendyType === "addNewPeople") {
        if (addNewPeopleType === "new") {
          // Validate name & email for NEW guest
          if (!formData.name.trim()) {
            errors.name = constantMessages.nameRequired;
          } else if (!regularExpressionName.test(formData.name)) {
            errors.name = constantMessages.invalidName;
          } else if (
            formData.name.trim().length < 3 ||
            formData.name.trim().length > 100
          ) {
            errors.name = constantMessages.stringLengthError;
          }

          if (!formData.email.trim()) {
            errors.email = constantMessages.emailRequired;
          } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            errors.email = constantMessages.invalidEmail;
          }

          // Optional fields
          if (formData?.designation?.trim()) {
            if (!regularExpression.test(formData.designation)) {
              errors.designation = constantMessages.invalidDesignation;
            } else if (
              formData.designation.length < 2 ||
              formData.designation.length > 100
            ) {
              errors.designation =
                "Designation must be between 2-100 characters.";
            }
          }

          if (formData?.companyName?.trim()) {
            if (!regularExpression.test(formData.companyName)) {
              errors.companyName = constantMessages.invalidCompanyName;
            } else if (
              formData.companyName.length < 2 ||
              formData.companyName.length > 50
            ) {
              errors.companyName =
                "Company name must be between 2-50 characters.";
            }
          }
        } else if (
          addNewPeopleType === "existing" &&
          (!selectedExistingGuestOption || !selectedExistingGuestOption.value)
        ) {
          // errors.responsiblePerson = constantMessages.responsiblePersonRequired;
        }
      } else {
        if (formData.email === null) {
          errors.responsiblePerson = constantMessages.responsiblePersonRequired;
        }
      }

      // Priority validation
      if (!formData?.priority?.trim()) {
        errors.priority = constantMessages.priorityRequired;
      }

      // Date validation
      if (formData?.date?.trim()) {
        const currentDate = new Date(props?.meetingDate);
        const inputDate = new Date(formData.date);
        let differenceInTime = inputDate.getTime() - currentDate.getTime();
        let differenceInDays = Math.round(
          differenceInTime / (1000 * 3600 * 24)
        );
        if (differenceInDays < 0) {
          errors.date = constantMessages.dateMoreThanMeetingDate;
        }
      } else {
        errors.date = constantMessages.dateRequired;
      }

      if (
        !attendData ||
        attendData.length === 0 ||
        attendData.every(
          (item) =>
            (!item.id || item.id.trim() === "") &&
            (!item.email || item.email.trim() === "")
        )
      ) {
        errors.responsiblePerson = constantMessages.responsiblePersonRequired;
      }
    }

    setErrors(errors);
    return errors;
  };

  const validateReasonForm = () => {
    const errors = {};
    if (formData.acceptStatus === "accept") {
      if (!formData.reason.trim()) {
        errors.reason = constantMessages.reasonRequired;
      } else if (
        formData.reason.trim().length < 3 ||
        formData.reason.trim().length > 500
      ) {
        errors.reason = constantMessages.largeStringLengthError;
      } else if (
        !regularExpressionForAgendaTitle.test(formData.reason.trim())
      ) {
        errors.reason = constantMessages.invalidReason;
      }

      if (formData.attendyType === "addNewPeople") {
        if (!formData.name.trim()) {
          errors.name = constantMessages.nameRequired;
        } else if (!regularExpressionName.test(formData.name)) {
          errors.name = constantMessages.invalidName;
        } else if (
          formData.name.trim().length < 3 ||
          formData.name.trim().length > 30
        ) {
          errors.title = constantMessages.stringLengthError;
        }

        if (!formData.email.trim()) {
          errors.email = constantMessages.emailRequired;
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
          errors.email = constantMessages.invalidEmail;
        }

        if (formData?.designation?.trim()) {
          if (!regularExpression.test(formData.designation)) {
            errors.designation = constantMessages.invalidDesignation;
          } else if (
            formData.designation.length < 2 ||
            formData.designation.length > 100
          ) {
            errors.designation =
              "Designation must be between 2-100 characters.";
          }
        }

        if (formData?.companyName?.trim()) {
          if (!regularExpression.test(formData.companyName)) {
            errors.companyName = constantMessages.invalidCompanyName;
          } else if (
            formData.companyName.length < 2 ||
            formData.companyName.length > 50
          ) {
            errors.companyName =
              "Company name must be between 2-50 characters.";
          }
        }
      }

      if (formData?.date?.trim()) {
        const currentDate = new Date(props.meetingDate);
        const inputDate = new Date(formData.date);
        let differenceInTime = inputDate.getTime() - currentDate.getTime();
        let differenceInDays = Math.round(
          differenceInTime / (1000 * 3600 * 24)
        );
        if (differenceInDays < 0) {
          errors.date = constantMessages.dateMoreThanMeetingDate;
        }
      }
    } else {
      if (!formData.reason.trim()) {
        errors.reason = constantMessages.reasonRequired;
      } else if (
        formData.reason.trim().length < 3 ||
        formData.reason.trim().length > 500
      ) {
        errors.reason = constantMessages.largeStringLengthError;
      }
    }
    setErrors(errors);
    return errors;
  };

  const closeModal = () => {
    setReason("");
    setErrors({});
    // alert("called")
    props.setIsReassignModalOpen(false);
    setFormData({
      ...formData,
      reason: "",
      priority: "",
      attendyType: "fromCurrentMeeting",
      responsiblePersonId: [],
      name: "",
      email: "",
      acceptStatus: "accept",
      date: null,
      designation: null,
      companyName: null,
      role: null,
      department: null,
    });
    setAttendData([{ id: "", name: "", email: "", profilePicture: "" }]);
    restoreAttendees();
  };

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const response = await dispatch(
          fetchExistingGuest(userData.organizationId, accessToken)
        );
        const guests = response.data || [];
        setAllGuestList(guests); // ✅ Store full list
      } catch (error) {
        console.error("Error fetching guests:", error);
      }
    };

    fetchGuests();
  }, []);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData?.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));

    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  const handleChange = (e) => {
    setErrors({});
    const { name, value } = e.target;

    let updatedValue = value;
    if (name === "email") {
      updatedValue = value.toLowerCase();
    }

    if (name === "reason") {
      if (updatedValue.length <= textBoxStrLength) {
        setFormData({
          ...formData,
          [name]: updatedValue,
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: updatedValue,
      });
    }

    if (updatedValue === "fromEmployeeList") {
      const payload = {
        organizationId: userData.organizationId,
      };

      dispatch(getEmployeeList(payload, accessToken));
    }

    if (updatedValue === "fromCurrentMeeting") {
      dispatch(
        fetchCurrentAttendeesList(
          userData.organizationId,
          props?.actionData?.meetingId,
          accessToken
        )
      );
    }

    if (updatedValue === "addNewPeople" && accessToken) {
      setAddNewSubOption("");

      const getGuests = async () => {
        try {
          const response = await dispatch(
            fetchExistingGuest(userData.organizationId, accessToken)
          );
          const guestData = response.data.map((value) => ({
            value: value._id,
            label: `${value.name}/${value.email}`,
            profilePicture: value.profilePicture,
          }));
          setExistingGuestOptions(guestData);
        } catch (error) {
          console.error("error", error);
        }
      };
      getGuests();
    }

    if (name === "attendyType" && updatedValue === "addNewPeople") {
      setAddNewPeopleType("new");
    }
  };

  const nameFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData.name.trim()) {
      errors.name = constantMessages.nameRequired;
    } else if (!regularExpressionName.test(formData.name)) {
      errors.name = constantMessages.invalidName;
    } else if (
      formData.name.trim().length < 3 ||
      formData.name.trim().length > 30
    ) {
      errors.name = constantMessages.nameLengthError;
    }
    setErrors(errors);
  };

  const emailFieldValidationCheck = (e) => {
    const errors = {};
    if (!formData?.email?.trim()) {
      errors.email = constantMessages.emailRequired;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = constantMessages.invalidEmail;
    }
    setErrors(errors);
  };

  useEffect(() => {
    if (employeeData?.employeeList?.length > 0) {
      const filtered = employeeData.employeeList.filter((emp) => {
        return !attendData?.some(
          (att) => att.email?.toLowerCase() === emp.email?.toLowerCase()
        );
      });

      const employeeOpt = filtered.map((attendee) => ({
        value: attendee._id,
        label: `${attendee.name} / ${attendee.empId}`,
        email: attendee.email,
        profilePicture: attendee.profilePicture,
        isEmployee: true,
      }));
      setEmployeeOptions(employeeOpt);
    }
  }, [employeeData, attendData]);

  useEffect(() => {
    const filteredGuests = allGuestList.filter((guest) => {
      return !attendData?.some(
        (att) => att.email?.toLowerCase() === guest.email?.toLowerCase()
      );
    });

    const options = filteredGuests.map((guest) => ({
      value: guest._id,
      label: `${guest.name} / ${guest.email}`,
      profilePicture: guest.profilePicture,
      email: guest.email,
    }));
    setExistingGuestOptions(options);
  }, [allGuestList, attendData]);

  const handleAttendeeChange = (e) => {
    setErrors({});
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedAttendeeOption(e);
  };
  const handleEmployeeChange = (e) => {
    setErrors({});
    const { name, value } = e;
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedEmployeeOption(e);
  };

  const handleGuestChange = (e) => {
    const { name, value } = e;
    setErrors({});
    setFormData({
      ...formData,
      [name]: value,
    });
    setSelectedExistingGuestOption(e);
  };

  const dateFieldValidationCheck = (e) => {
    const errors = {};
    if (formData?.date?.trim()) {
      const currentDate = new Date(props?.meetingDate);
      const inputDate = new Date(formData.date);
      let differenceInTime = inputDate.getTime() - currentDate.getTime();
      let differenceInDays = Math.round(differenceInTime / (1000 * 3600 * 24));
      if (differenceInDays < 0) {
        errors.date = constantMessages.dateMoreThanMeetingDate;
      }
    } else {
      errors.date = constantMessages.dateRequired;
    }
    setErrors(errors);
  };

  const preventEnterKey = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const assignAction = async () => {
    const attendeesToAdd = [];
    setAddedUserError("");
    setErrors({});

    // 1. From Guest Dropdown
    if (selectedAttendeeOption && selectedAttendeeOption.value) {
      const [namePart, emailPart] = selectedAttendeeOption.label.split(" / ");
      attendeesToAdd.push({
        id: selectedAttendeeOption.value,
        name: namePart.trim(),
        email: emailPart.trim(),
        isEmployee: selectedAttendeeOption.isEmployee,
        profilePicture: selectedAttendeeOption.profilePicture,
        isNewUser: false,
      });

      // ✅ Remove from guest dropdown options
      setAttendeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedAttendeeOption.value)
      );
    }

    // 2. From Employee Dropdown
    if (selectedEmployeeOption && selectedEmployeeOption.value) {
      attendeesToAdd.push({
        id: selectedEmployeeOption.value,
        name: selectedEmployeeOption.label.split(" / ")[0].trim(),
        email: selectedEmployeeOption.email,
        isEmployee: selectedEmployeeOption.isEmployee,
        profilePicture: selectedEmployeeOption.profilePicture,
        isNewUser: false,
      });

      // ✅ Remove from employee dropdown options
      setEmployeeOptions((prev) =>
        prev.filter((opt) => opt.value !== selectedEmployeeOption.value)
      );
    }

    // 3. From New or Existing Guest under "Add New People"
    if (formData.attendyType === "addNewPeople") {
      // 3a. Existing guest
      if (addNewPeopleType === "existing" && selectedExistingGuestOption) {
        const [guestName, guestEmail] =
          selectedExistingGuestOption.label.split("/");
        const profilePicture = selectedExistingGuestOption.profilePicture;
        attendeesToAdd.push({
          id: selectedExistingGuestOption.value,
          name: guestName.trim(),
          email: guestEmail.trim(),
          profilePicture: profilePicture,
          isEmployee: false,
          isNewUser: false,
        });
        setExistingGuestOptions((prev) =>
          prev.filter((opt) => opt.value !== selectedExistingGuestOption.value)
        );
      }

      // 3b. New guest
      else if (addNewPeopleType === "new" && formData.name && formData.email) {
        const duplicateInToAdd = attendeesToAdd.find(
          (u) => u.email.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInToAdd) {
          setErrors({ duplicateAttendee: constantMessages.duplicateAttendee });
          return;
        }

        const duplicateInExisting = attendData?.find(
          (att) => att.email?.toLowerCase() === formData.email.toLowerCase()
        );
        if (duplicateInExisting) {
          setAddedUserError(constantMessages.attendeeExist);
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }

        try {
          const payload = {
            organizationId: userData.organizationId,
            email: formData.email,
          };

          await new Promise((resolve) => {
            dispatch(checkDuplicateUser(payload, accessToken));
            setTimeout(resolve, 1000);
          });

          if (employeeData.isDuplicateUser === true) {
            setAddedUserError(
              "This email is already registered in the system!"
            );
            setTimeout(() => setAddedUserError(""), 3000);
            return;
          }
          // alert("called this");
          attendeesToAdd.push({
            name: formData.name,
            email: formData.email,
            companyName: formData.companyName || "",
            designation: formData.designation || "",
            role: formData.role || "",
            department: formData.department || "",
            isNewUser: true,
          });
          setFormData((prev) => ({
            ...prev,
            name: "",
            email: "",
            designation: "",
            companyName: "",
          }));
        } catch (error) {
          console.error("Error checking for duplicate user:", error);
          setAddedUserError("Error checking user. Please try again.");
          setTimeout(() => setAddedUserError(""), 3000);
          return;
        }
      }
    }

    if (attendeesToAdd.length === 0) return;

    // ✅ Merge attendees into attendData
    setAttendData((prevAttendData) => {
      const existing = prevAttendData || [];

      const normalizedExisting = existing.map(({ _id, ...rest }) => ({
        id: _id || rest.id,
        ...rest,
      }));

      const normalizedToAdd = attendeesToAdd.map(({ _id, ...rest }) => ({
        id: _id || rest.id,
        ...rest,
      }));

      const validToAdd = normalizedToAdd.filter(
        (att) => att.name?.trim() && att.email?.trim()
      );

      const uniqueAttendees = [
        ...normalizedExisting,
        ...validToAdd.filter(
          (newOne) =>
            !normalizedExisting.some(
              (existingOne) =>
                existingOne.email?.toLowerCase() === newOne.email?.toLowerCase()
            )
        ),
      ];

      if (uniqueAttendees.length === existing.length) {
        setAddedUserError(constantMessages.attendeeExist);
        setTimeout(() => setAddedUserError(""), 3000);
        return prevAttendData;
      }

      return uniqueAttendees;
    });

    setSelectedAttendeeOption(null);
    setSelectedEmployeeOption(null);
    setSelectedExistingGuestOption(null);
  };

  const removeAttendee = (e) => {
    const removedAttendee = attendData.find(
      (item) => item.email === removeAttendeeData.email
    );
    if (!removedAttendee) return;
    const filteredAttendees = attendData.filter(
      (item) => item.email !== removeAttendeeData.email
    );
    setAttendData(filteredAttendees);
    setAttendData((prev) => prev.filter((id) => id !== removedAttendee._id));

    setFormData((prevFormData) => ({
      ...prevFormData,
      attendeeId: null,
    }));
    setIsModalOpen(false);
  };

  const restoreAttendees = () => {
    setAttendData(props?.actionData?.assignedUserDetails);
  };
  const updatedAttendeesData = (attendees) => {
    setAttendData(props?.actionData?.assignedUserDetails);
  };

  return (
    <>
      <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
        {props.activity ? (
          <>
            <div className="modal-header">
              <h4 className="modal-title">Forward Request</h4>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={closeModal}
              ></button>
            </div>
          </>
        ) : (
          <div className="modal-header">
            <h4 className="modal-title">Forward</h4>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={closeModal}
            ></button>
          </div>
        )}
        <div className="modal-body">
          {props.activity ? (
            <>
              <div className="delete-txt">
                <label className="input-date mb-1">Remark</label>

                <p>{props.activity}</p>
              </div>
              <div className="minutes-border"></div>
            </>
          ) : null}
          <form>
            {props.activity ? (
              <div className="d-flex w-100">
                <div className="form-check form-check-inline">
                  <input
                    id="flexRadioDefault1"
                    className="form-check-input"
                    type="radio"
                    name="acceptStatus"
                    value="accept"
                    onChange={handleChange}
                    checked={formData.acceptStatus === "accept"}
                  />
                  <label
                    for="flexRadioDefault1"
                    id="flexRadioDefault1"
                    className="form-check-label"
                  >
                    Accept
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      id="flexRadioDefault2"
                      type="radio"
                      name="acceptStatus"
                      value="reject"
                      onChange={handleChange}
                      checked={formData.acceptStatus === "reject"}
                    />
                    <label
                      className="form-check-label"
                      for="flexRadioDefault2"
                      id="flexRadioDefault2"
                    >
                      Reject
                    </label>
                  </div>
                </div>
              </div>
            ) : null}
            {formData.acceptStatus === "accept" ? (
              <>
                <div className={`form-group ${props.activity ? "mt-3" : ""}`}>
                  <div className="position-relative">
                    <label className="mb-1 input-date">
                      Reasons
                      <span className="star-mark">*</span>
                    </label>
                    <div>
                      <textarea
                        cols="40"
                        rows="4"
                        id="remark"
                        name="reason"
                        onBlur={validateReasonForm}
                        onChange={handleChange}
                        value={formData.reason}
                        placeholder="Enter your reason here..."
                        required
                      ></textarea>
                      <div className="d-flex align-items-center justify-content-between">
                        {errors.reason && (
                          <span className="error-message">{errors.reason}</span>
                        )}
                        <p className="success-message">
                          {checkCharacterLeft(formData.reason)} Characters left
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <div className="position-relative">
                    <label className="input-date mb-1"> Due Date</label>

                    <div
                      className="relative"
                      onClick={() =>
                        document.getElementById("dateInput").showPicker()
                      }
                    >
                      <input
                        type="date"
                        id="dateInput"
                        name="date"
                        value={formData.date}
                        onChange={handleChange}
                        onBlur={dateFieldValidationCheck}
                      />
                    </div>
                  </div>
                  {errors.date && (
                    <span className="error-message">{errors.date}</span>
                  )}
                </div>
                <div className="form-group">
                  <div className="position-relative">
                    <label className="input-date mb-1">Priority</label>
                    <div>
                      <select
                        name="priority"
                        id="priority"
                        value={formData.priority}
                        onChange={handleChange}
                      >
                        <option value="">Select Priority</option>
                        <option value="HIGH">High</option>
                        <option value="NORMAL">Normal</option>
                        <option value="LOW">Low</option>
                      </select>
                    </div>
                  </div>
                  {errors.priority ? (
                    <span className="error-message">{errors.priority}</span>
                  ) : null}
                </div>
                <div className="form-group">
                  <RemoveAttendeesModalAction
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    attendee={removeAttendeeData}
                    meetingData={meetingData}
                    allowRemove={true}
                    message="Are you sure want to remove this attendee?"
                    handleSubmit={() =>
                      removeAttendee(props?.actionData?.assignedUserDetails)
                    }
                  />
                  <label className="mb-1">Select Responsible Person(s)</label>
                  <AttendeeDragDropNew
                    attendees={attendData}
                    updatedAttendeesData={updatedAttendeesData}
                    setIsModalOpen={setIsModalOpen}
                    setRemoveAttendeeData={setRemoveAttendeeData}
                    allowRemove={true}
                  />
                  <div className="w-100 mt-2">
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="attendyType"
                        value="fromCurrentMeeting"
                        id="flexRadioDefault5"
                        onChange={handleChange}
                        checked={formData.attendyType === "fromCurrentMeeting"}
                      />

                      <label
                        className="mb-2 form-check-label"
                        for="flexRadioDefault5"
                        id="flexRadioDefault5"
                      >
                        Select From Current Meeting
                      </label>
                    </div>

                    <div className="form-check-inline">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="attendyType"
                          value="fromEmployeeList"
                          id="flexRadioDefault4"
                          onChange={handleChange}
                          checked={formData.attendyType === "fromEmployeeList"}
                        />
                        <label
                          className=" mb-2 form-check-label"
                          for="flexRadioDefault4"
                          id="flexRadioDefault4"
                        >
                          Select From Employees
                        </label>
                      </div>
                    </div>

                    <div className="form-check-inline">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="attendyType"
                          value="addNewPeople"
                          id="flexRadioDefault3"
                          checked={formData.attendyType === "addNewPeople"}
                          onChange={handleChange}
                        />
                        <label
                          className=" mb-2 form-check-label"
                          for="flexRadioDefault3"
                          id="flexRadioDefault3"
                        >
                          Add Guest
                        </label>
                      </div>
                    </div>
                  </div>

                  {formData.attendyType === "fromCurrentMeeting" ? (
                    <Select
                      className="fltr-opt"
                      placeholder="*Name / Email Address"
                      name="attendeeId"
                      options={attendeeOptions}
                      onChange={handleAttendeeChange}
                      value={selectedAttendeeOption}
                      defaultValue={selectedAttendeeOption}
                    />
                  ) : formData.attendyType === "fromEmployeeList" ? (
                    <Select
                      className="fltr-opt"
                      placeholder="*Name / Employee ID"
                      name="attendeeId"
                      options={employeeOptions}
                      value={selectedEmployeeOption}
                      onChange={handleEmployeeChange}
                      defaultValue={selectedEmployeeOption}
                    />
                  ) : formData.attendyType === "addNewPeople" ? (
                    <div>
                      <label className="mb-1 mt-2">Select Guest Type</label>
                      <select
                        name="addNewPeopleType"
                        className="form-control"
                        value={addNewPeopleType}
                        onChange={(e) => setAddNewPeopleType(e.target.value)}
                      >
                        <option value="new" defaultChecked={true}>
                          Add New Guest
                        </option>
                        <option value="existing">Select from Existing</option>
                      </select>

                      {addNewPeopleType === "new" ? (
                        <>
                          <label className="mt-3 mb-1">Add New Guest</label>
                          <div className="row">
                            <div className="col-xl-6 col-md-6">
                              <input
                                type="text"
                                autoComplete="off"
                                placeholder="*Name"
                                name="name"
                                onKeyDown={preventEnterKey}
                                value={formData.name}
                                onChange={handleChange}
                                onBlur={nameFieldValidationCheck}
                              />
                              {errors.name && (
                                <span className="error-message">
                                  {errors.name}
                                </span>
                              )}
                            </div>
                            <div className="col-xl-6 col-md-6">
                              <input
                                type="text"
                                placeholder="*Email"
                                autoComplete="off"
                                name="email"
                                value={formData.email}
                                onKeyDown={preventEnterKey}
                                onBlur={emailFieldValidationCheck}
                                onChange={handleChange}
                              />
                              {errors.email && (
                                <span className="error-message">
                                  {errors.email}
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-xl-6 col-md-6 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                placeholder="Designation"
                                name="designation"
                                onKeyDown={preventEnterKey}
                                value={formData.designation}
                                onChange={handleChange}
                              />
                              {errors.designation && (
                                <span className="error-message">
                                  {errors.designation}
                                </span>
                              )}
                            </div>

                            <div className="col-xl-6 col-md-6 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                placeholder="Company Name"
                                name="companyName"
                                onKeyDown={preventEnterKey}
                                value={formData.companyName}
                                onChange={handleChange}
                              />
                              {errors.companyName && (
                                <span className="error-message">
                                  {errors.companyName}
                                </span>
                              )}
                            </div>
                            <div className="col-xl-6 col-md-6 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                placeholder="Role"
                                name="role"
                                onKeyDown={preventEnterKey}
                                value={formData.role}
                                onChange={handleChange}
                              />
                              {errors.role && (
                                <span className="error-message">
                                  {errors.role}
                                </span>
                              )}
                            </div>

                            <div className="col-xl-6 col-md-6 mt-2">
                              <input
                                type="text"
                                autoComplete="off"
                                placeholder="Department"
                                name="department"
                                onKeyDown={preventEnterKey}
                                value={formData.department}
                                onChange={handleChange}
                              />
                              {errors.department && (
                                <span className="error-message">
                                  {errors.department}
                                </span>
                              )}
                            </div>
                          </div>
                        </>
                      ) : addNewPeopleType === "existing" ? (
                        <>
                          <label className="mt-2">Select Existing</label>
                          <Select
                            className="fltr-opt mt-2"
                            placeholder="*Name / Email Address"
                            name="attendeeId"
                            defaultValue={existingGuestOptions}
                            options={existingGuestOptions}
                            onChange={handleGuestChange}
                            value={selectedExistingGuestOption}
                          />
                        </>
                      ) : null}
                    </div>
                  ) : null}

                  {errors.responsiblePerson ? (
                    <span className="error-message">
                      {errors.responsiblePerson}
                    </span>
                  ) : null}
                </div>
              </>
            ) : (
              <div className="form-group">
                <div className="position-relative">
                  <label className="pb-2 input-date">Reason</label>
                  <span className="star-mark">*</span>
                  <div>
                    <textarea
                      cols="40"
                      rows="4"
                      id="remark"
                      name="reason"
                      onBlur={validateForm}
                      onChange={handleChange}
                      value={formData.reason}
                      placeholder="Enter your reason here..."
                      required
                    ></textarea>
                    <p className="success-message">
                      {checkCharacterLeft(formData.reason)} Characters left
                    </p>
                    {errors.reason && (
                      <span className="error-message">{errors.reason}</span>
                    )}
                  </div>
                </div>
              </div>
            )}
          </form>
          {formData.acceptStatus !== "reject" && (
            <button
              type="button"
              className="btn add-btn Mom-btn d-flex align-items-center justify-content-center"
              onClick={assignAction}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="#fff"
                className="bi bi-plus-circle pointer me-2"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
              </svg>
              <p> Add </p>
            </button>
          )}
          {addedUserError && (
            <span className="error-message">{addedUserError}</span>
          )}
        </div>
        <div className="modal-footer">
          {!actionData.updateLoading &&
          actionData.isSuccess &&
          formData.acceptStatus === "accept" ? (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Forward</p>
            </button>
          ) : !actionData.updateLoading &&
            actionData.isSuccess &&
            formData.acceptStatus === "reject" ? (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Reject</p>
            </button>
          ) : (
            <div className="meeting-page " style={{ textAlign: "center" }}>
              <SmallLoaderButton />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ReassignModal;
